/**
 * @desc 通过UPC,GTIN,SKU,ITEM_ID检索产品,productId代表产品code
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(body: defs.walmart.WalmartProductRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/walmart/systemProduct/getSkuInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
